// Import the functions you need from the SDKs you need
// Use @firebase/* directly to avoid module-registry mismatches with
// firebase/* sub-package resolution under react-scripts 5.
import { initializeApp } from "@firebase/app";
import { getAnalytics } from "@firebase/analytics";
import { getAuth } from "@firebase/auth";
import { getFirestore } from "@firebase/firestore";
import { getFunctions } from "@firebase/functions";
import { getStorage } from "@firebase/storage";

// SECURITY: Firebase config must come from environment variables
// No hardcoded fallbacks - app should fail explicitly if not configured
// Set these in .env.local (for dev) or in your deployment environment
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};


// Validate required config
const requiredFields = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];
const missingFields = requiredFields.filter(field => !firebaseConfig[field]);
if (missingFields.length > 0) {
  console.error('Missing Firebase configuration fields:', missingFields);
  throw new Error(`Missing Firebase configuration fields: ${missingFields.join(', ')}`);
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const storage = getStorage(app);

// Analytics : initialisé UNIQUEMENT en production (résolution de modules
// react-scripts 5) ET après consentement analytics de l'utilisateur —
// CookieBanner / CookiePreferencesPopin / /cookies-settings, choix persisté
// en localStorage par useCookieConsentStore (clé partagée ci-dessous).
// initAnalytics() est rappelée par le store quand l'utilisateur accepte en
// cours de session ; un refus empêche toute injection au chargement.
const COOKIE_CONSENT_STORAGE_KEY = 'rabbit_cookie_consent';
let analytics = null;
const initAnalytics = () => {
  if (analytics) return analytics;
  if (process.env.NODE_ENV !== 'production' || !firebaseConfig.measurementId) return null;
  try {
    const raw = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw || JSON.parse(raw).analytics !== true) return null;
    analytics = getAnalytics(app);
  } catch (err) {
    console.warn('[Firebase] Analytics initialization skipped:', err);
  }
  return analytics;
};
initAnalytics();

export { app, analytics, auth, db, functions, storage, initAnalytics };
